export default {"src":"/_next/static/media/icon-twitter-circle.101b7426.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};